/* eslint-disable import/no-cycle */
import React from "react";
import PropTypes from "prop-types";
import { cloudinaryImageAdapter } from "../../sharedComponents/CloudinaryImageAdapter";
import { BannerExperience } from "./BannerExperience";

const BannerExperienceConnector = ({ data }) => (
	<BannerExperience
		image={{
			...cloudinaryImageAdapter({
				cloudinaryImage: data?.cloudinaryImage?.[0],
				desc: data?.title,
				title: data?.title,
			}),
		}}
		link={{
			url: data?.link.url,
			target: data?.link.target,
			linkText: data?.link.linkText,
			externalModalMessage: data?.link.externalModalMessage,
		}}
		text={data?.content?.childMarkdownRemark?.html}
	/>
);

BannerExperienceConnector.propTypes = {
	data: PropTypes.object.isRequired,
};

export default BannerExperienceConnector;
export { BannerExperienceConnector };
